/* eslint-disable @next/next/no-html-link-for-pages */
import { Col, Row } from 'antd';

import EventDetail from '../EventCategory/EventDetail';

import classes from './index.module.less';
// const { Text } = Typography;

const EventDetailContainer = (props: any) => {
	// const { xs } = Grid.useBreakpoint();

	return (
		<div className={classes['page-body-wrap']}>
			<div className="container">
				<div className={classes.headContact}>
					{/* <Row>
						<Col>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									marginBottom: '20px',
									fontSize: xs ? '11px' : '14px',
								}}
							>
								<a href="/event" style={{ marginLeft: '8px', color: '#000' }}>
									Semua Event
								</a>
								<Text style={{ margin: '0 8px' }}>/</Text>
								<Text style={{ marginLeft: '8px', color: '#DBD1D1' }}>{props.event.title}</Text>
							</div>
						</Col>
					</Row> */}
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<EventDetail {...props.event} />
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default EventDetailContainer;
